import { http, createConfig } from 'wagmi'
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  rainbowWallet,
  walletConnectWallet,
  coinbaseWallet,
  injectedWallet,
  metaMaskWallet,
  safeWallet,
  trustWallet,
  rabbyWallet,
} from '@rainbow-me/rainbowkit/wallets';

export const abstractChain = {
  id: 146,
  name: 'Sonic',
  nativeCurrency: { name: 'Sonic', symbol: 'S', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://rpc.soniclabs.com'] },
  },
  blockExplorers: {
    default: { name: 'Sonicscan', url: 'https://sonicscan.org' },
  },
//   multicall: {
//     address: '0xcA11bde05977b3631167028862bE2a173976CA11', // Multicall3 address on Ethereum Mainnet
//     blockCreated: 14353601, // Block number where Multicall3 was deployed on Ethereum
// },
}

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        rabbyWallet,
        metaMaskWallet,
        rainbowWallet,
        // walletConnectWallet,
        coinbaseWallet,
        injectedWallet,
        safeWallet,
        trustWallet,
      ],
    },
  ],
  {
    appName: 'Milkit',
    projectId: 'YOUR_PROJECT_ID',
  }
);

export const config = createConfig({
  chains: [abstractChain],
  connectors,
  transports: {
    [abstractChain.id]: http(),
  },
  publicClient: http({ chainId: abstractChain.id, url: abstractChain.rpcUrls.default.http[0] }),
})